<template>
<el-main>
  <div class="container-con shop_form">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-position="top">
      <el-form-item label="Email Address" prop="email">
        <el-col :lg="10" :sm='18'>
          <el-input placeholder="Please enter a valid email to receive the video." v-model="ruleForm.email"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Additional Info" prop="note">
        <el-col :lg="10" :sm='18'>
          <el-input placeholder="Please enter the additional information here." v-model="ruleForm.note"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="Amount" prop="type">
        <el-row>
          <el-col :lg="6" :sm='12' :key="index" v-for="(dia, index) in diamonds">
            <div class="phase center-aligned"
              :class="phase == dia.phase? 'active' : ''"
              @click="phase=dia.phase">
              <img v-show="phase!=dia.phase" src="@/assets/img/shop/video_02.png">
              <img v-show="phase==dia.phase" src="@/assets/img/shop/video_01.png">
              <h3>{{ dia.title }}</h3>
              <p>Reward-{{ dia.diamond }} diamonds</p>
              <div class="phase_but"><p>${{ dia.price }}</p></div>
              <img class="phase_mark" src="@/assets/img/shop/shop_right.png">
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item prop="agreement">
        <el-checkbox-group v-model="ruleForm.agreement">
          <el-checkbox size="medium" name="type">
            Please read <router-link target="_blank" :to="{ name: 'agreement' }">The User Agreement</router-link>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button class="submit" type="primary" @click="submitForm('ruleForm')">Buy now</el-button>
      </el-form-item>
    </el-form>
  </div>
</el-main>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    var checkEmail = (rule, value, callback) => {
      var reg = new RegExp('^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$')
      if (!reg.test(value)) {
        callback(new Error('Please enter a valid email address'))
      } else {
        callback()
      }
    }
    var checkInfo = (rule, value, callback) => {
      this.$axios.get('/poker/api/user_info.php?uid=' + value).then((res) => {
          if(res.status === 200 && res.data.code === 0) {
            callback()
          }else {
            callback(new Error('The Additonal Infomation is incorrect'))
          }
        }).catch(function (error) {
          callback(new Error('The Additonal Infomation is incorrect'))
        })
    }
    return {
      ruleForm: {
        email: '',
        note: '',
        agreement: []
      },
      rules: {
        email: [
          { required: true, message: 'Email Address should not be empty', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        note: [
          { required: true, message: 'Additional Info should not be empty', trigger: 'blur' },
          { validator: checkInfo, trigger: 'blur' }
        ],
        agreement: [
          { required: true, message: 'Please read the user agreement', trigger: 'change' }
        ]
      },
      phase: 1,
      diamonds: [
        { phase: 1, title: 'Beginner', diamond: '5k' , num: '5000', price: '77' },
        { phase: 2, title: 'Intermediate', diamond: '10k', num: '10000', price: '150' },
        { phase: 3, title: 'Advanced ①', diamond: '50k', num: '50000', price: '729' },
        { phase: 4, title: 'Advanced ②', diamond: '100k', num: '100000', price: '1418' }
      ]
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.get('/poker/api/user_info.php?uid=' + this.ruleForm.note).then((res) => {
            console.log(res)
            if(res.status === 200 && res.data.code === 0) {
              this.$router.push({
                name: 'shop-pay',
                query: {
                  phaseid: this.phase,
                  phase: this.diamonds[this.phase - 1].title,
                  name: this.ruleForm.note,
                  email: this.ruleForm.email,
                  amount: this.diamonds[this.phase - 1].price,
                  diamond: this.diamonds[this.phase - 1].diamond,
                  num: this.diamonds[this.phase - 1].num,
                  headimgurl: res.data.headimgurl,
                  nickname: res.data.nickname,
                }
              })
            }
          })
            .catch(function (error) {})
        } else {
          return false
        }
      })
    }
  },
  created () {
    this.$store.commit('changeTab', '/pc/shop')
  }
}
</script>

<style lang="scss">
.shop_form .el-form {
  .el-form-item__label {
    font-size: 22px;
  }
  .el-input__inner {
    font-size: 16px;
    border-color: #aaaaaa;
  }
  .el-form-item__error {
    font-size: 16px;
  }
  .el-checkbox__label {
    font-size: 18px;
    vertical-align: middle;
    padding-left: 4px;
  }
  .el-checkbox__inner {
    width: 19px;
    height: 19px;
  }
  .el-checkbox__inner::after {
    left: 7px;
    top: 4px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.container-con {
  margin: 45px auto 100px auto;
}
.el-form {
  .el-form-item {
    margin-bottom: 30px;
    .el-checkbox-group {
      line-height: 25px;
      a {
        color: #4686f1;
        box-shadow: 0 1px;
      }
    }
    .phase {
      padding: 18px;
      width: 206px;
      min-height: 266px;
      border: 1px solid #e4e4e4;
      margin: 3px;
      cursor: pointer;
      position: relative;
      img {
        width: 122px;
        margin-top: 15px;
      }
      h3 {
        font-size: 24px;
        color: #1a1919;
        margin: 0px;
      }
      p {
        font-size: 16px;
        color: #616161;
        line-height: 22px;
        margin: 0px 0px 30px 0px;
      }
      .phase_but {
        height: 36px;
        width: 100%;
        border-radius: 18px;
        background-color: #565761;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
        p {
          line-height: 36px;
          color: #fff;
          font-size: 24px;
        }
      }
      .phase_mark {
        display: none;
        position: absolute;
        right: 0px;
        bottom: 0px;
        width: 38px;
      }
    }
    .phase.active {
      border: 4px solid #4686f1;
      margin: 0px;
      .phase_but {
        background-color: #4686f1;
      }
      .phase_mark {
        display: block;
      }
    }
  }
  .el-button.submit {
    width: 156px;
    height: 40px;
    font-size: 22px;
    color: #fff;
    padding: 0px 20px;
    border-radius: 20px;
    margin-top: 5px;
  }
}
</style>
